import { CloseRounded, PrintRounded } from "@mui/icons-material";
import { Box, Divider, IconButton } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../../App";
import { action, controller, Server } from "../../../api/Server";
import { PrintDiv, ToFormData } from "../../../hooks/Method";
import MinimalCloseRegAcc from "./MinimalCloseRegAcc";
import { Button } from "../../../controls";
import MinimalPrintReceipt from "./MinimalPrintReceipt";
import { useNavigate } from "react-router-dom";

const MinimalCloseReg = ({ setShowForm }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { settings, selStore, setLoader, loader } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [openReg, setOpenReg] = useState({});

  const handlePrint = () => {
    PrintDiv("MinimalPrintReceipt");
  };

  const handleCloseReg = () => {
    setLoading(true);
    Server(controller.Register + action.MinimalCloseReg).post(
      ToFormData({
        storeId: selStore,
        dateTime: new Date().toISOString(),
      }),
      (res) => {
        if (res?.status === 200) {
          setOpenReg({ ...res.result });
          setTimeout(() => {
            handlePrint();
            setShowForm(false);
            navigate("/");
          }, 1000);
        } else {
          setLoading(false);
          console.error("Error: ", res);
        }
      }
    );
  };

  useEffect(() => {
    if (selStore) {
      setLoader(true);
      Server(controller.Register + action.OpenRegAcc).post(
        ToFormData({
          storeId: selStore,
          dateTime: new Date().toISOString(),
        }),
        (res) => {
          res.status === 200 && setOpenReg({ ...res.result });
          setLoader(false);
        }
      );
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selStore]);

  return (
    <>
      {openReg && (
        <Box className="d-none" id="MinimalPrintReceipt">
          <MinimalPrintReceipt values={openReg} />
        </Box>
      )}

      <div className="tx-center d-flex j-between a-center p-5">
        <span className="fs-18 gray-color tx-upp border-left ml-5">
          {t("cashRegisterReport")}
        </span>
        <IconButton size="small" onClick={() => setShowForm(false)}>
          <CloseRounded />
        </IconButton>
      </div>
      <Divider />
      {openReg?.id && settings && !loader ? (
        <>
          <MinimalCloseRegAcc values={openReg} settings={settings} />
          <div className="p-10 d-flex g-10">
            <Button
              startIcon={<PrintRounded />}
              onClick={handlePrint}
              variant="text"
              fullWidth
            >
              {t("print")}
            </Button>
            <Button
              color="error"
              fullWidth
              loading={loading}
              onClick={handleCloseReg}
            >
              {t("closeRegister")}
            </Button>
          </div>
        </>
      ) : (
        <div className="pb-20 pt-20 pl-10 pr-10">
          <span className="fs-18 fw-5 gray-color">
            {" "}
            {loader ? "Loading..." : t("regNotOpenYet")}
          </span>
        </div>
      )}
    </>
  );
};

export default MinimalCloseReg;
